import React, { FC } from 'react';

import { ROUTER_PATHS } from '@constants/router';
import IfoodLogoRed from 'images/ifood-logo-merchant-api.svg';

import { HomeLink, Logo } from './styles';

const HeaderLogo: FC = () => (
  <HomeLink noStyles dataTestId="header-logo-home-link" href={ROUTER_PATHS.HOME}>
    <Logo alt="logo" src={IfoodLogoRed} />
  </HomeLink>
);

export default HeaderLogo;
